import { Button, Row, Col } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { useEffect , useState } from 'react';
import Barcode from 'react-barcode';
import _isEmpty from 'lodash/isEmpty';
import { useStore } from 'store';
import { withLayout } from 'hocs';
import { GiftsReceivedLayout2 } from 'components';
import { TableList } from 'components/gifts-table/TableList';
import {
  fetchElectronicWalletInfo,
  fetchGiftTableInfo,
} from 'store/actions/giftTable';
import { useStorage64 ,useWindowSize} from 'hooks';
import { CURRENT_GIFT_TABLE, AGENT_STAFF, AGENT_STAFF_TOKEN } from 'constants/storage64';
import { CurrencyFormat } from 'components/Helpers';
import { Link } from 'react-router-dom'
import mimonedero from 'assets/img/mimonedero.png';
import { da, es } from 'date-fns/locale';
import { getTableDate } from 'components/gifts-table/TableHero/utils';
import BarMobile from 'pages/Header/Content/components/BarMobile';
import styles from './styles.module.scss';
import { columns } from './columns';

const { parse, format } = require('date-fns');

function MyWallet() {
  const history = useHistory();
  const [storageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
  // eslint-disable-next-line no-unused-vars
  const [storageAgentStaffId, setAgentStaffId] = useStorage64(AGENT_STAFF, '');
  const [storageAgentStaffToken, setAgentStaffToken] = useStorage64(AGENT_STAFF_TOKEN, '');
  const barcode = sessionStorage.getItem('ver_barcode');
  console.log('VERBARCODE:',barcode);
  const headeradminfinal = sessionStorage.getItem('admin_header');
  console.log('headeradminfinal:',headeradminfinal);
  const [walletTransactions, setWalletTransactions] = useState([]);
  const [,{isMobile}] = useWindowSize()


  const [tableData, dispatch] = useStore(
    (state) => state.giftTable.giftTableInfo.data
  );
  const [walletFullInfo] = useStore(
    (state) => state.giftTable.electronicWalletInfo.data
  );

  const handleClickReturnGifts = () => {
    history.push('/regalos-recibidos/');
  };

  useEffect(() => {
    if (_isEmpty(tableData)) {
      dispatch(
        fetchGiftTableInfo({ id: storageGiftTable.id, showLoader: true })
      );
    } else {
      !storageAgentStaffId && setAgentStaffToken('');
      const agentToken = storageAgentStaffId ? storageAgentStaffToken : null
      dispatch(fetchElectronicWalletInfo(tableData.wallet.wallet_id, agentToken));
    }
  }, [tableData]);

  useEffect(() => {
    if(walletFullInfo?.transactions){
      // console.clear();
      console.log('walletFullInfo', walletFullInfo.transactions);
      const {transactions} = walletFullInfo;
      for (const key in transactions) {
        transactions[key].transaction_status = 'Monto transferido';
        /* let date = transactions[key].transaction_date;
        date = date.split(' ');
        date = date[0].split('/');
        date = date[2] + '-' + date[1] + '-' + date[0]+' 00:00:00';
        const eventDate = new Date(date.replace(' ', 'T'));
        transactions[key].transaction_date = parse(eventDate, 'dd/MM/yyyy', { locale: es }); */
        // transactions[key].transaction_date = getTableDate(transactions[key].transaction_date);
      }
      console.log('transactions', transactions);
      setWalletTransactions(transactions);
    }
  }, [walletFullInfo]);

  console.log(walletTransactions)
  // console.log('walletFullInfo: ',walletFullInfo)

  return (
      <>
        <BarMobile pageName='Mis regalos recibidos' marginBottom='12px'/>
        <div className="text-center">
          <h1 className={styles['title-and-image']}>
            <img src={mimonedero} alt="QR Icon" className={styles.image}/>  Mi monedero SEARS
          </h1>
          <hr width = '90%' />
        </div>
        <GiftsReceivedLayout2 showAccumulatedAmount={false} showNameEvent = {!isMobile}>
          <div className={styles['details-container']}>
            <Row className="justify-content-center">
              <Col lg={12} className="d-flex align-items-center my-4">
                <div className={styles.walletDetails}>
                  <div className="giftDetail__item d-flex justify-content-between align-items-center my-2">
                    <p className="text-uppercase font-weight-bold mb-0">
                      Total transferido a monedero:
                    </p>
                    <CurrencyFormat
                        className="text-primary mb-0 ml-2 text-right"
                        price={walletFullInfo?.total_amount}
                    />
                  </div>
                  <div className="giftDetail__item d-flex justify-content-between align-items-center my-2">
                    <p className="text-uppercase font-weight-bold mb-0">
                      Saldo actual disponible en monedero:
                    </p>
                    <CurrencyFormat
                        className="text-primary mb-0 ml-2 text-right"
                        price={walletFullInfo?.current_amount}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col lg={6} className="text-center">
                {headeradminfinal !== 'null' && barcode !== null && (
                    <div className="text-center">
                      <Barcode displayValue={false} value={walletFullInfo?.wallet_code} />
                      <h4 className="font-weight-bold mb-3" id="con_var">
                        {/* {walletFullInfo?.wallet_code_masked} */}
                        {walletFullInfo?.wallet_code}
                      </h4>
                    </div>
                )}
                {headeradminfinal !== 'null' && !barcode && (
                    <div className="text-center" id="sin_text" />
                )}
                {headeradminfinal === 'null' && !barcode && (
                    <div className="text-center">
                      <Barcode displayValue={false} value={walletFullInfo?.wallet_code} />
                      <h4 className="font-weight-bold mb-3" id="sin_var">
                        {/* {walletFullInfo?.wallet_code_masked} */}
                        {walletFullInfo?.wallet_code}
                      </h4>
                    </div>
                )}
              </Col>
            </Row>
            {
              isMobile ? (
                <p className="text-center mt-3">
                  Recibe todo el dinero en tu monedero eletrónico Sears y compra los que más te guste en Sears.com.mx y en tu tienda Sears.
                </p>
              ) : (
                <>
                  <p className="text-center mt-3">
                    Recibe todo el dinero en tu monedero electrónico Sears y compra
                  </p>
                  <p className="text-center mt-3">
                    los que más te guste en Sears.com.mx y en tu tienda Sears
                  </p>
                </>
              )
            }
            <p className="text-center mt-3">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link className={styles.link}>Conoce cómo</Link>
            </p>
          </div>

          <Row className="justify-content-center">
            <Col xs={12}>
              {
                isMobile ? (
                  <div className={styles['wallet-transaction-container']}>
                    <span className={styles.title}>Detalle de movimientos</span>
                    {
                      walletTransactions.map((item,index) => (
                        <div className={styles['item-container']}>
                          <article className={styles.about}>
                            <div className={styles['amount-and-description']}>
                              <span className={styles.description}>{item.description}</span>
                              <span className={styles.amount}>${item.amount}</span>
                            </div>
                            <span className={styles.reason}>{item.transaction_status}</span>
                          </article>
                          <span className={styles.date}>{item.transaction_date}</span>
                        </div>
                      ))
                    }
                  </div>
                ):(
                  <TableList
                      className="mt-4 mb-5"
                      data={walletTransactions || []}
                      columns={columns()}
                      clickableRow
                      message="Aún no tienes bonificaciones a Monedero"
                      dataType="wallet-transactions"
                  />
                )
              }
            </Col>
          </Row>
        </GiftsReceivedLayout2>
      </>

  );
}

export default withLayout(MyWallet);
